module.exports = __webpack_public_path__ + "static/media/montserrat-extra-light.62b90633.woff2";